export default __webpack_public_path__ + "static/media/about-bg-01.8ae45298.png";